import React from 'react';
// components
import RecoveryForm from 'components/forms/RecoveryForm/RecoveryForm';

const RecoveryPage = () => {
  return (
    <main className="auth-page">
      <section className="auth">
        <div className="auth__container">
          <h1 className="auth__title">Забули пароль?</h1>
          <strong className="auth__msg auth__msg--recovery"> Введіть номер телефону і ми надішлемо посилання для відновлення! </strong>
          <RecoveryForm />
        </div>
      </section>
    </main>
  );
};

export default RecoveryPage;
